module.exports = __webpack_public_path__ + "img/enrtance-plant@2x.6e6ea7f3.webp";